module.exports = __webpack_public_path__ + "fonts/fontello.e73a0647.eot";